import { createFileRoute } from '@tanstack/react-router';
import EmployeeShiftDailyTable from '@/modules/employees/employee-daily/EmployeeShiftDailyTable';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/employee/shift-daily')({
  component: EmployeeShiftDailyTable,
});
